import script from "./BetslipModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BetslipModal.vue?vue&type=script&setup=true&lang=ts"

import "./BetslipModal.vue?vue&type=style&index=0&id=fd778154&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd778154"]])

export default __exports__